
import React from 'react';
import { cn } from '@/lib/utils';

type ActivityStatusProps = {
  status: 'upcoming' | 'in_progress' | 'completed' | 'cancelled';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

export const ActivityStatus: React.FC<ActivityStatusProps> = ({ 
  status,
  className,
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'px-3 py-1.5'
  };

  const statusClasses = {
    upcoming: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
    in_progress: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
    completed: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
    cancelled: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
  };

  const statusLabels = {
    upcoming: 'À venir',
    in_progress: 'En cours',
    completed: 'Terminée',
    cancelled: 'Annulée'
  };

  return (
    <span className={cn(
      'rounded-full font-medium whitespace-nowrap',
      sizeClasses[size],
      statusClasses[status],
      className
    )}>
      {statusLabels[status]}
    </span>
  );
};
